/**
 * Strongly-typed DOM query helper that throws a descriptive error if the element is missing.
 */
export function getRequiredElement<T extends HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) {
    throw new Error(`Critical DOM element not found: #${id}`);
  }
  return el as T;
}

/**
 * Escapes HTML characters for safe insertion into innerHTML.
 */
export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
